import CrudTable from './CrudTable';
import { endpoints } from '../../services/api';

const Agentes = () => {
  return (
    <CrudTable
      title="Agentes"
      apiEndpoint={endpoints.oficina.agentes}
      columns={[
        { key: 'nombre', label: 'Nombre' }
      ]}
      formFields={[
        { name: 'nombre', label: 'Nombre', required: true }
      ]}
    />
  );
};

export default Agentes;

